export const ASSIGNED_CARGO_DELETE_TOOLTIP = 'Remove this cargo from the flight before deleting it.';

export function getCargoDeleteDisabledReason(cargo: { currentCarrierID?: unknown }): string | undefined {
    return cargo.currentCarrierID == null ? undefined : ASSIGNED_CARGO_DELETE_TOOLTIP;
}
